<!--
  name : 김혜진
  desc :
  date : 2020-10-05
-->
<template>
<v-navigation-drawer id="navbg"
  mini-variant
  permanent
  absolute
>

  <v-divider></v-divider>
  <v-list nav dense>
    <ul class="menu_nav">
      <li>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link @click="goDash"
            v-bind="attrs" v-on="on">
              <v-list-item-icon class="navI menu_home">
              </v-list-item-icon>
              <v-list-item-title>대시보드</v-list-item-title>
            </v-list-item>
          </template>
          <div>대시보드</div>
        </v-tooltip>
      </li>
    </ul>
  </v-list>
  <v-divider></v-divider>
  <v-list nav dense>
    <ul class="menu_nav">
      <li class="write">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link text
                @click="goContractWrite()"
                v-bind="attrs" v-on="on">
                <v-list-item-icon class="navI">
                </v-list-item-icon>
                <v-list-item-title>계약작성</v-list-item-title>
              </v-list-item>
            </template>
            <div>계약작성</div>
          </v-tooltip>
        </li>
    </ul>
  </v-list>
  <v-list nav dense>
    <ul class="menu_nav">
      <li class="document">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link text
                @click="goContractList()"
                v-bind="attrs" v-on="on">
                <v-list-item-icon class="navI">
                </v-list-item-icon>
                <v-list-item-title>보관함</v-list-item-title>
              </v-list-item>
            </template>
            <div>보관함</div>
          </v-tooltip>
        </li>
    </ul>
  </v-list>
  <v-list nav dense>
    <ul class="menu_nav">
      <li class="feepay">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link text
                @click="goPayInfo()"
                v-bind="attrs" v-on="on">
                <v-list-item-icon class="navI">
                </v-list-item-icon>
                <v-list-item-title>요금정보</v-list-item-title>
              </v-list-item>
            </template>
            <div>요금정보</div>
          </v-tooltip>
        </li>
    </ul>
  </v-list>
  <v-list nav dense  v-if="getComanyAuth()">
    <ul class="menu_nav">
      <li class="auth">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link text
                @click="goCompanyAuth()"
                v-bind="attrs" v-on="on">
                <v-list-item-icon class="navI">
                </v-list-item-icon>
                <v-list-item-title>기업인증</v-list-item-title>
              </v-list-item>
            </template>
            <div>기업인증</div>
          </v-tooltip>
        </li>
    </ul>
  </v-list>
  <v-list nav dense >
    <ul class="menu_nav">
      <li class="pd-0">
        <v-menu top :offset-x="offset">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip right>
              <template v-slot:activator="{ on: tooltip }">
                <v-list-item
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }">
                  <v-list-item-icon class="navI menu_cpnWrite">
                  </v-list-item-icon>
                  <v-list-item-title>사내계약</v-list-item-title>
                </v-list-item>
              </template>
              <div>사내계약</div>
            </v-tooltip>
          </template>
          <v-list dense class="setMenu_list">
            <v-list-item link @click="goCreateOfficeContract()" v-bind="attrs" v-on="on"  v-if="getOrgname()">
              <v-list-item-title>사내계약 작성</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="goOfficeContractList()" v-bind="attrs" v-on="on">
              <v-list-item-title>사내계약 조회</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </li>
    </ul>
  </v-list>
  <v-list nav dense >
    <ul class="menu_nav">
      <li class="pd-0 setting">
        <v-menu top :offset-x="offset">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip right>
              <template v-slot:activator="{ on: tooltip }">
                <v-list-item
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }">
                  <v-list-item-icon class="navI menu_cpnWrite">
                  </v-list-item-icon>
                  <v-list-item-title>설정</v-list-item-title>
                </v-list-item>
              </template>
              <div>설정</div>
            </v-tooltip>
          </template>
          <v-list dense class="setMenu_list">
            <v-list-item link @click="goOrgConfig()" v-bind="attrs" v-on="on">
              <v-list-item-title>사용자 설정</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="goContract()" v-bind="attrs" v-on="on">
              <v-list-item-title>계약 정보 설정</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="goChain()" v-bind="attrs" v-on="on">
              <v-list-item-title>블록 체인 관리</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="goVerify()" v-bind="attrs" v-on="on">
              <v-list-item-title>계약 파일 검증</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item link @click="goDepartment()" v-bind="attrs" v-on="on">
              <v-list-item-title>부서 설정</v-list-item-title>
            </v-list-item> -->
            <v-list-item link @click="goCrew()" v-bind="attrs" v-on="on" v-if="getOrgname()">
              <v-list-item-title>사원 관리</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </li>
    </ul>
  </v-list>
  </v-navigation-drawer>
</template>
<script>

export default {
  name: 's-navigation',
  components: {
  },
  filters: {
  },
  data () {
    return {
      csMenus: [],
      offset: true,
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    goDash() {
      //this.$router.push({ name: "dashboard" })
      window.location = process.env.VUE_APP_RESPONSE_URL + "/main"
    },
    goCreateOfficeContract() {
      //this.$router.push('createOfficeContract')
      window.location = process.env.VUE_APP_RESPONSE_URL + "/createOfficeContract"
    },
    goOfficeContractList() {
      //this.$router.push('officeContractList')
      window.location = process.env.VUE_APP_RESPONSE_URL + "/officeContractList"
    },
    goOrgConfig() {
      //this.$router.push('orgConfig')
      window.location = process.env.VUE_APP_RESPONSE_URL + "/orgConfig"
    },
    goContract() {
      //this.$router.push('scontract')
      window.location = process.env.VUE_APP_RESPONSE_URL + "/scontract"
    },
    goChain() {
      //this.$router.push('chain')
      window.location = process.env.VUE_APP_RESPONSE_URL + "/chain"
    },
    goVerify() {
      //this.$router.push('verify')
      window.location = process.env.VUE_APP_RESPONSE_URL + "/verify"
    },
    goContractWrite() {
      window.location = process.env.VUE_APP_RESPONSE_URL + "/write"
    },
    goCompanyAuth() {
      window.location = process.env.VUE_APP_RESPONSE_URL + "/companyAuth"
    },
    goContractList() {
      window.location = process.env.VUE_APP_RESPONSE_URL + "/list"
    },
    goPayInfo() {
      window.location = process.env.VUE_APP_RESPONSE_URL + "/feePay"
    },
    getComanyAuth() {
      return this.$store.state.user.orgtmp
    },
    // goDepartment() {
    //   this.$router.push('department')
    // },
    goCrew() {
      //this.$router.push('crew')
      window.location = process.env.VUE_APP_RESPONSE_URL + "/crew"
    },
    getOrgname() {
      return this.$store.state.user.orgname
    },
  }
}
</script>
<style scoped>
</style>
